module.exports = __webpack_public_path__ + "img/logo-loading.21abe0cf.png";